import styled from 'styled-components';

export const NavButtonsStyle = styled.div`
  display: flex;
  position: fixed;
  bottom: 0;
  max-width: 376px;
  margin: 0 auto;
  padding: 16px;
  width: 100%;
  background: white;
  transform: translateX(-16px);
  z-index: 1;
  opacity: 1;
  visibility: visible;
  transition: 0.3s ease-in-out all;
  .nav-buttons-item {
    width: 100%;
    &.with-icon {
      margin-right: 16px;
      width: 56px;
    }
  }

  .MuiButtonBase-root {
    width: 100%;
  }

  &.hide {
    opacity: 0;
    visibility: hidden;
  }
`;
